import React, { useState } from "react";
import PropTypes from "prop-types";
import moment from "moment";

import usePermissions from "hooks/usePermissions";
import AnalyticsContext from "./analyticsContext";

function AnalyticsProvider({ children }) {
  const { permissions } = usePermissions();
  const { company_id } = JSON.parse(permissions);
  const [analyticParams, setAnalyticParams] = useState({
    company_id,
    payment_location: null,
    date_range: "year_to_date",
    date_from: null,
    date_to: null,
    analytics_filter_by: "month",
    filter_date_range_by: "request_date",
  });
  const [isStacked, setIsStacked] = useState(false);

  const setCompanyId = (companyId) => {
    setAnalyticParams({
      ...analyticParams,
      company_id: companyId,
    });
  };

  const setPaymentLocation = (paymentLocation) => {
    if (paymentLocation === "All") {
      setAnalyticParams({
        ...analyticParams,
        payment_location: null,
      });
      return;
    }
    setAnalyticParams({
      ...analyticParams,
      payment_location: paymentLocation,
    });
  };

  const setDateRange = (dateRange) => {
    if (dateRange !== "custom_date_range") {
      setAnalyticParams({
        ...analyticParams,
        date_range: dateRange,
        date_from: null,
        date_to: null,
      });
    }
  };

  const setCustomDateRange = (dateFrom, dateTo) => {
    setAnalyticParams((prev) => ({
      ...prev,
      date_range: "custom_date_range",
      date_from: moment(dateFrom).format("DD-MM-YYYY"),
      date_to: moment(dateTo).format("DD-MM-YYYY"),
    }));
  };

  const setAnalyticsFilterBy = (analyticsFilterBy) => {
    setAnalyticParams({
      ...analyticParams,
      analytics_filter_by: analyticsFilterBy,
    });
  };

  const setFilterDateRangeBy = (filterDateRangeBy) => {
    setAnalyticParams({
      ...analyticParams,
      filter_date_range_by: filterDateRangeBy,
    });
  };

  // eslint-disable-next-line react/jsx-no-constructed-context-values
  const analyticsContext = {
    params: analyticParams,
    setCompanyId,
    setPaymentLocation,
    setDateRange,
    setCustomDateRange,
    setAnalyticsFilterBy,
    setFilterDateRangeBy,
    isStacked,
    setIsStacked,
  };

  return <AnalyticsContext.Provider value={analyticsContext}>{children}</AnalyticsContext.Provider>;
}

AnalyticsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AnalyticsProvider;
